angular.module('record-list.pagination').component('recordListPagination', {
    templateUrl: 'modules/record-list/pagination/template.html',
    bindings: {
        pageIndexes: '<',
        pageSelectionActive: '<',
        currentPage: '<',
        gridOptions: '<',
        onNavigate: '&',
    },
    controller: [
        '$document',
        '$scope',
        '$timeout',
        '$filter',
        function RecordListPaginationController($document, $scope, $timeout, $filter) {
            var vm = this;

            vm.showInputForPage = null;
            vm.inputPageValue = '';
            vm.buttonWidth;
            vm.buttonHeight;

            vm.$onInit = function() {
                vm.parentNavigateToPage = $scope.$parent.navigateToPage;
            };

            vm.$onChanges = function(changesObj) {
                if (changesObj.pageIndexes) {
                    vm.processPageIndexes(changesObj.pageIndexes.currentValue);
                }

                if (!vm.parentNavigateToPage && $scope.$parent && $scope.$parent.navigateToPage) {
                    vm.parentNavigateToPage = $scope.$parent.navigateToPage;
                }
            };

            vm.processPageIndexes = function(indexes) {
                vm.displayIndexes = Array.isArray(indexes) ? indexes : [];
            };

            vm.navigateToPage = function(pageIndex) {
                if (vm.parentNavigateToPage && typeof vm.parentNavigateToPage === 'function') {
                    vm.parentNavigateToPage(pageIndex);
                }
                else {
                    $scope.$emit('navigateToPage', pageIndex);
                    vm.currentPage = pageIndex;
                }
            };

            vm.translatePage = function(text) {
                if (vm.gridOptions && vm.gridOptions.translateFilter) {
                    return $filter(vm.gridOptions.translateFilter)(text, vm.locale);
                }

                return text;
            };

            vm.handlePageButtonClick = function(pageIndex, event) {
                if (pageIndex === vm.currentPage) {
                    event.preventDefault();
                    event.stopPropagation();

                    var button = event.currentTarget;
                    vm.buttonWidth = button.offsetWidth;
                    vm.buttonHeight = button.offsetHeight;

                    vm.inputPageValue = pageIndex + 1;
                    vm.showInputForPage = pageIndex;
                } else {
                    vm.navigateToPage(pageIndex);
                }
            };

            vm.validateInput = function() {
                var value = vm.inputPageValue;
                var totalPages = Math.ceil(vm.gridOptions.totalItems / vm.gridOptions.pageItems);

                return value !== '' && !isNaN(parseInt(value, 10)) && parseInt(value, 10) >= 1 && parseInt(value, 10) <= totalPages;
            };

            vm.isInputValid = function(pageIndex) {
                if (vm.showInputForPage === pageIndex) {
                    return vm.validateInput();
                }

                return true;
            };

            vm.restoreButton = function(pageIndex) {
                $timeout(function() {
                    if (vm.showInputForPage === pageIndex) {
                        vm.showInputForPage = null;
                    }
                }, 100);
            };

            vm.handleInputKeydown = function(event, pageIndex) {
                if (event.which === 13) {
                    event.preventDefault();

                    if (!vm.validateInput()) {
                        return false;
                    }

                    var newPageIndex = parseInt(vm.inputPageValue, 10) - 1;
                    if (isNaN(newPageIndex) || newPageIndex < 0) {
                        newPageIndex = 0;
                    }

                    vm.restoreButton(pageIndex);
                    vm.navigateToPage(newPageIndex);
                }

                if (event.which === 27) {
                    vm.restoreButton(pageIndex);
                }
            };

            vm.onInputRendered = function(inputId) {
                $timeout(function() {
                    var inputElement = $document.getElementById(inputId);
                    if (inputElement) {
                        inputElement.focus();
                        inputElement.select && inputElement.select();
                    }
                });
            };
        },
    ],
});
